import React, { FC } from 'react';
import { ReactComponent as Add } from '../../../assets/Common/Add.svg';

export const AddIcon: FC = () => <Add />;
